import { createAction, props } from '@ngrx/store';
import { Officer } from '../models/list-officer.models';
import { ListOfficerActionResult } from '../models/list-officer-action-result.models';
import { HttpErrorResponse } from '@angular/common/http';

export const listOfficer = createAction('[ListOfficer] List Officer');
export const listOfficerSuccess = createAction('[ListOfficer] List Officer Success', props<{ officers: Officer[] }>());

export const listPaginationOfficers = createAction('[ListOfficer] List Pagination Officers', props<{ query: string }>());
export const listPaginationOfficersSuccess = createAction(
  '[ListOfficer] List Pagination Officers Success',
  props<{ paginationOfficers: Officer[]; query: string; filteredOfficersTotalCount: number }>()
);

export const deleteOfficer = createAction('[ListOfficer] Delete Officer', props<{ uid: string }>());
export const deleteOfficerSuccess = createAction('[ListOfficer] Delete Officer Success', props<{ uid: string }>());

export const listOfficerActionResult = createAction('[ListOfficer] List Officer Action Result', props<{ actionResult: ListOfficerActionResult }>());

export const inviteUser = createAction('[ListOfficer] Invite User', props<{ uid: string }>());
export const inviteUserSuccess = createAction('[ListOfficer] Invite User Success', props<{ uid: string }>());
export const inviteUserFail = createAction('[ListOfficer] Invite User Fail', props<{ uid: string; error: string | HttpErrorResponse }>());
